/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Badge, Button, Form, Modal, Table } from 'react-bootstrap';
import moment from 'moment';
import { ExamServices } from '../../../../Services/examServices';
import { toast } from 'react-toastify';
import ExamStatus from './ExamStatus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBullhorn,
  faCheck,
  faCheckCircle,
  faCircleDot,
  faCircleQuestion,
  faClock,
  faEllipsisVertical,
  faGear,
  faKey,
  faPenAlt,
  faPencil,
  faRefresh,
  faReplyAll,
  faSquarePollVertical,
  faStamp,
  faTimesCircle,
  faTrash,
  faUpload,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import Toolbar from '../../../../components/Toolbar/Toolbar';
import UploadCandidateData from '../../../../components/Modals/UploadCandidateData.modal';
import CardBasic from '../../../../components/Cards/Card.basic';
import ExamUserTable from './ExamUserTable';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import PromptModal from '../../../../components/Modals/Prompt.modal';
import './ExamTime.css';
import { CSVDownload } from 'react-csv';
import TimeModal from './TimeModal';
import { ClientService } from 'Services/ClientService';
import DCMDropdown from 'components/DropDown/DropDown.index';
import TablePagination from 'components/Pagination/Table.paginaition';
import Select from "react-select"
import CenterAdmin from './CenterAdmin';
interface ISelectedExam {
  examData: any;
  reloadData: any;
}

interface IInitialExamStatus {
  startAllowed: any;
  downloadData: any;
  userShow: any;
}

const TimeType = {
  examTime: {
    label: 'Exam Enabled(Reporting) and Disable(Maximum allowed Till) Time',
    type: 'examTime',
  },
  userAllowedTime: {
    label: 'Exam Duration Time',
    type: 'userAllowedTime',
  },
  userTillTime: {
    label: 'Gate Closing Time',
    type: 'userTillTime',
  },
};

export default function SelectedExamCard({
  examData,
  reloadData,
}: ISelectedExam) {
  const [examStatus, setExamStatus] = useState<IInitialExamStatus | any>({
    startAllowed: '',
    downloadData: '',
    userShow: '',
  });

  const params: any = useParams();
  const navigate = useNavigate();

  const [showCandidateDataModal, setShowCandidateDataModel] =
    useState<boolean>(false);
  const [confirmPrompt, setConfirmPrompt] = useState<boolean>(false);

  const [userData, setUserData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageCount, setPageCount] = useState(20);
  const [userAllowedExamTime, setUserAllowedExamTime] = useState({
    userAllowedStartTime: '',
    userAllowedEndTime: '',
  });

  const [examTimeModal, setExamTimeModal] = useState<boolean>(false);
  const [downloadData, setDownloadData] = useState<any>();
  const [date_type, setDate_type] = useState<{
    type: string;
    label: string;
  }>();

  const [examTime, setExamTime] = useState<{
    startTime: string;
    endTime: string;
  }>();
  const [userAllowedTime, setUserAllowedTime] = useState<{
    startTime: string;
    endTime: string;
  }>();
  const [userTillTime, setUserTillTime] = useState('');

  const [showCreateClientModal, setShowCreateClientModal] = useState<boolean>(false)
  const [clientData, setClientData] = useState<any>();
  const [clients, setClients] = useState<any>();
  const [showPasswordModal, setShowPasswordModal] = useState<boolean>(false)
  const [clientPassword, setClientPassword] = useState<any>();
  const [showResetClientPasswordModal, setShowResetClientPasswordModal] = useState<boolean>(false)
  const [clientResetData, setClientResetData] = useState<any>();
  const [pageSize, setPageSize] = useState<number>(1000000000);
  const [total, setTotal] = useState<number>(0);
  const [selectedCity, setSelectedCity] = useState<any>();
  const [cities, setCities] = useState<any>();


  const getAllExamCities = async () => {
    await ExamServices.getAllExamCities(params.examId).then((res) => {
      if (res.status === 200) {
        setCities(res.data?.uniqueCitites?.map((data: any) => {
          return {
            label: data,
            value: data
          }
        }))
      }
    })
  }

  const getAllClient = async () => {
    await ClientService.getAllClient(params.examId).then((res) => {
      if (res.status === 200) {
        setClients(res.data.data.clients)
      }
    })
  }

  const handleCreateClient = async () => {
    await ClientService.createClient({ examId: params.examId, username: clientData }).then((res) => {
      if (res.status === 200) {
        setClientPassword(res.data?.data)
        setShowPasswordModal(true)
        setShowCreateClientModal(false)
        getAllClient();
      }
    }).catch(err => {
      toast.error(err.response)
    })
  }

  const handleUpdateClientPassword = async () => {
    await ClientService.updateClientPassword(params?.examId, { password: clientResetData }).then((res) => {
      if (res.status === 200) {
        toast.success("Client Password Updated")
        setShowResetClientPasswordModal(false)
        getAllClient();
      }
    }).catch(err => {
      toast.error(err.response)
    })
  }

  const handleDeleteClient = async (clientId: any) => {
    await ClientService.deleteClient(clientId).then((res) => {
      if (res.status === 200) {
        toast.success("Client Deleted")
        getAllClient();
      }
    }).catch(err => {
      toast.error("Unable to delete client.")
    })
  }




  const formatDate = (date: any) => {
    return moment(date).format('DD-MMM-YYYY hh:mm a');
  };

  const examStatusData = async () => {
    await ExamServices.getExamStatus(params.examId)
      .then((res) => {
        if (res.status === 200) {
          setExamStatus(res.data);
        }
      })
      .catch((err) => {
        toast.error(err.response);
      });
  };

  const getAllMappedUser = async () => {
    await ExamServices.getAllUsers(params.examId, selectedCity?.value, pageNumber, pageSize).then((res) => {
      setUserData(res.data.data.users);
      setTotal(res.data.data.totalCount)
      setTotalPages(1)
    }).catch((err) => {
      toast.error('Unable to fetch User data');
    });
  };

  const makeExamLive = async () => {
    await ExamServices.makeExamLive(params.examId).then((res) => {
      if (res.status === 200) {
        toast.success('Exam is Live');
        reloadData();
      }
    });
  };


  const makeExamNotLive = async () => {
    await ExamServices.updateExamStatus(
      {
        startAllowed: false,
        downloadData: false,
        userShow: false,
      },
      params.examId,
    )
      .then((res) => {
        if (res.status === 200) {
          toast.success('Exam is not live');
          setExamStatus(!examStatus);
        }
      })
      .catch((err) => {
        toast.error(err.response);
      });
  };

  const handleDeleteExamMapping = async () => {
    await ExamServices.deleteMappingForExam(params.examId).then((res) => {
      if (res.status === 200) {
        toast.success('Clear Mapping');
        reloadData();
        setConfirmPrompt(false);
      }
    });
  };

  const markExamCompleted = async () => {
    await ExamServices.markExamCompleted(params.examId).then((res) => {
      if (res.status === 200) {
        toast.success('Exam Status Changed');
        reloadData();
      }
    });
  };

  const getUserAllowedExamTime = async () => {
    await ExamServices.getUserAllowedExamTime(params.examId)
      .then((res) => {
        if (res.status === 200) {
          setUserAllowedExamTime(res.data.data);
        }
      })
      .catch((err) => { });
  };

  const handleTimeExamTime = async () => {
    // TODO : update on backend
    // await ExamServices.setExamDateAndTime(
    //   params.examId,
    //   examTime?.startTime ?? examData.startTime,
    //   examTime?.endTime ?? examData.end,
    // );
    // setExamTimeModal(false);
    await ExamServices.setExamDateAndTime(
      params.examId,
      examTime?.startTime ?? examData.startTime,
      examTime?.endTime ?? examData.endTime,
    ).catch((err) => console.log(err));
    setExamTimeModal(false);
    reloadData()
  };

  const handleUserTillTime = async () => {
    await ExamServices.setUserAllowedTillTime(
      params.examId,
      userTillTime ?? examData.userAllowedTillTime,
    ).catch((err) => console.error(err, true));
    setExamTimeModal(false);
    reloadData()
  };

  console.log(examData, "id")

  const handleUserAllowedTime = async () => {
    await ExamServices.setUserAllowedTime(
      params.examId,
      userAllowedTime?.startTime ?? userAllowedExamTime.userAllowedStartTime,
      userAllowedTime?.endTime ?? userAllowedExamTime.userAllowedEndTime,
    ).then(() => setExamTimeModal(false));
    reloadData()
  };

  const defaultTime =
    date_type === TimeType.examTime
      ? {
        start: examData.startTime,
        end: examData.endTime,
      }
      : date_type === TimeType.userAllowedTime
        ? {
          start: userAllowedExamTime.userAllowedStartTime,
          end: userAllowedExamTime.userAllowedEndTime,
        }
        : date_type === TimeType.userTillTime
          ? {
            start: examData.userAllowedTillTime,
          }
          : {};



  useEffect(() => {
    examStatusData();
    getUserAllowedExamTime();
  }, [examData, examTimeModal]);

  useEffect(() => {
    getAllMappedUser();
  }, [pageNumber, pageCount, examData, showCandidateDataModal, selectedCity]);

  useEffect(() => {
    getAllClient();
    getAllExamCities();
  }, [])

  return (
    <>
      <PromptModal
        setShow={setConfirmPrompt}
        show={confirmPrompt}
        body={
          <>
            <div>
              <p>Are you sure you want to Delete All Users?</p>
            </div>
          </>
        }
        submitButton={
          <Button
            variant="danger"
            className="ms-2"
            onClick={handleDeleteExamMapping}
          >
            Delete Users <FontAwesomeIcon icon={faTrash} />
          </Button>
        }
      />
      {examTimeModal && (
        <TimeModal
          show={examTimeModal}
          setShow={setExamTimeModal}
          type={date_type}
          onTimeChange={(start, end) => {
            const ISOStart = start;
            const ISOEnd = end;
            if (date_type === TimeType.examTime) {
              setExamTime({ startTime: ISOStart, endTime: ISOEnd });
              return;
            }
            if (date_type === TimeType.userAllowedTime) {
              setUserAllowedTime({ startTime: ISOStart, endTime: ISOEnd });
              return;
            }
            if (date_type === TimeType.userTillTime) {
              setUserTillTime(ISOStart);
              return;
            }
          }}
          onSubmit={() => {
            if (date_type === TimeType.examTime) {
              handleTimeExamTime();
              return;
            }
            if (date_type === TimeType.userAllowedTime) {
              handleUserAllowedTime();
              return;
            }
            if (date_type === TimeType.userTillTime) {
              handleUserTillTime();
              return;
            }
          }}
          defaultValues={defaultTime}
        />
      )}
      <CardBasic
        cardClass="mt-2"
        body={
          <>
            <div className="d-flex justify-content-end"></div>
            <div className="d-flex justify-content-between mt-2">
              <div>
                <div className="d-flex justify-content-start align-items-center">
                  <span>
                    Name: <b>{examData?.examName}</b>
                  </span>
                  <div className="ms-2">
                    <span>
                      {examStatus.startAllowed &&
                        examStatus.downloadData &&
                        examStatus.userShow ? (
                        <Badge bg="danger" className="me-2">
                          LIVE
                        </Badge>
                      ) : (
                        <Badge bg="info" className="me-2">
                          NOT LIVE
                        </Badge>
                      )}
                    </span>
                  </div>
                </div>
                <div>
                  <span>
                    Subject: <b>{examData?.subject}</b>
                  </span>
                </div>
              </div>

              <div>
                <div>
                  <span>
                    Created at <b>{formatDate(examData.createdAt)}</b>
                  </span>
                </div>

                <div>
                  <span>
                    Last updated at <b>{formatDate(examData.updatedAt)}</b>
                  </span>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-start align-items-center mt-3 mb-3">
              {examData.tags
                ? examData.tags.map((tag: any) => {
                  return (
                    <>
                      <Badge bg="secondary" className="me-2">
                        {tag}
                      </Badge>
                    </>
                  );
                })
                : ''}
            </div>
            <div>
              <span>
                Status:{' '}
                <b>{examData.markAsCompleted ? <span className="text-success">Completed <FontAwesomeIcon icon={faCheckCircle} className="ms-1" /></span> : <span className="text-danger">In Progress <FontAwesomeIcon icon={faCircleDot} className="ms-1" /></span>}</b>
              </span>
            </div>
            <div className="bg-primary-light mt-5">
              <ExamStatus data={examStatus} reloadData={reloadData} />
            </div>

            <hr />
            <h6 className="fw-bold">
              Exam Timings:
            </h6>
            <Table borderless responsive="md" className="xrg-text-12" size="sm">
              <thead>
                <tr>
                  <th>Time Type</th>
                  <th>Start Time/From</th>
                  <th>End Time/To</th>
                  <th>Duration</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-primary fw-bold">
                    Enabled Time
                  </td>
                  <td className="text-secondary">
                    {formatDate(examData.startTime)}
                  </td>
                  <td className="text-secondary">
                    {formatDate(examData.endTime)}
                  </td>
                  <td className="text-secondary">
                    ---
                  </td>
                  <td>
                    <FontAwesomeIcon icon={faPencil} className="text-primary cursor-pointer" onClick={() => {
                      setDate_type(TimeType.examTime);
                      setExamTimeModal(true);
                    }
                    } />
                  </td>
                </tr>
                <tr>
                  <td className="text-primary fw-bold">
                    Duration Time
                  </td>
                  <td className="text-secondary">
                    {formatDate(examData.userAllowedStartTime)}
                  </td>
                  <td className="text-secondary">
                    {formatDate(examData.userAllowedEndTime)}
                  </td>
                  <td className="text-secondary">
                    {moment(examData.userAllowedEndTime).diff(moment(examData.userAllowedStartTime), "minutes") + " min(s)"}
                  </td>
                  <td>
                    <FontAwesomeIcon icon={faPencil} className="text-primary cursor-pointer" onClick={() => {
                      setDate_type(TimeType.userAllowedTime);
                      setExamTimeModal(true);
                    }
                    } />
                  </td>
                </tr>
                <tr>
                  <td className="text-primary fw-bold">
                    Gate Closing Time
                  </td>
                  <td className="text-secondary">
                    {formatDate(examData.userAllowedTillTime)}
                  </td>
                  <td className="text-secondary">
                    ---
                  </td>
                  <td className="text-secondary">
                    ---
                  </td>
                  <td className="text-secondary">
                    <div className='d-flex justify-content-between'>
                      <div>
                        <FontAwesomeIcon icon={faPencil} className="text-primary cursor-pointer" onClick={() => {
                          setDate_type(TimeType.userTillTime);
                          setExamTimeModal(true);
                        }
                        } />
                      </div>

                    </div>
                  </td>

                </tr>
              </tbody>
            </Table>
          </>

        }
      />

      <CardBasic
        cardClass="mt-3"
        body={
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <h5>Client</h5>
              <Button size="sm" variant="danger" onClick={() => setShowCreateClientModal(true)}>Create Client</Button>
            </div>
            <div className="mt-3">
              <Table striped borderless className="xrg-table" size="sm" responsive="md">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    {/* <th>Exam ID</th> */}
                    <th>Username</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {clients && clients?.length > 0 && clients?.map((data: any, index: number) => {
                    return (
                      <tr>
                        <td>{index + 1}</td>
                        {/* <td>{data?.exam}</td> */}
                        <td>{data?.username}</td>
                        <td>
                          <DCMDropdown
                            menuItems={[
                              {
                                label: (
                                  <div className="text-secondary">
                                    <FontAwesomeIcon icon={faRefresh} className="me-2" />
                                    Reset Password
                                  </div>
                                ),
                                onClick: () => setShowResetClientPasswordModal(true)
                              },
                              {
                                label: (
                                  <div className="text-danger">
                                    <FontAwesomeIcon icon={faTrash} className="me-2" />
                                    Delete Client
                                  </div>
                                ),
                                onClick: () => handleDeleteClient(data?._id)
                              },
                            ]}
                            menuLabel={
                              <FontAwesomeIcon
                                icon={faEllipsisVertical}
                                className="cursor-pointer"
                              />
                            }
                            title={
                              <div className="text-primary fw-bold">
                                {data.student && data.student.name + ' ' + data.student.last_name}
                              </div>
                            }
                          />
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        }
      />

      <CardBasic
        cardClass="mt-3"
        body={
          <div className="d-flex justify-content-between align-items-center">


            <Toolbar
              values={[
                {
                  value: (
                    <>
                      {examStatus.startAllowed &&
                        examStatus.downloadData &&
                        examStatus.userShow ? (
                        <>
                          <FontAwesomeIcon
                            icon={faBullhorn}
                            size="sm"
                            className="me-2"
                          />
                          Stop Live Exam
                        </>
                      ) : (
                        <>
                          {' '}
                          <FontAwesomeIcon
                            icon={faBullhorn}
                            size="sm"
                            className="me-2"
                          />
                          Make Exam Live
                        </>
                      )}
                    </>
                  ),
                  onClick: () =>
                    examStatus.startAllowed &&
                      examStatus.downloadData &&
                      examStatus.userShow
                      ? makeExamNotLive()
                      : makeExamLive(),
                  variant:
                    examStatus.startAllowed &&
                      examStatus.downloadData &&
                      examStatus.userShow
                      ? 'danger'
                      : 'secondary',
                },
                {
                  value: (
                    <>
                      <FontAwesomeIcon
                        icon={faCheck}
                        size="sm"
                        className="me-2"
                      />
                      {examData.markAsCompleted ? "Mark as Incomplete" : "Mark as Completed"}
                    </>
                  ),
                  onClick: markExamCompleted,
                  variant: examData.markAsCompleted ? "danger" : "success",
                },

                {
                  value: (
                    <>
                      <FontAwesomeIcon
                        icon={faGear}
                        size="sm"
                        className="me-2"
                      />
                      Check Live Exam
                    </>
                  ),
                  onClick: () => {
                    navigate('/admin-dash/live-exam/' + examData._id, {
                      state: 1,
                    });
                  },
                  variant: 'secondary',
                },
                {
                  value: (
                    <>
                      <FontAwesomeIcon
                        icon={faReplyAll}
                        size="sm"
                        className="me-2"
                      />
                      User Response
                    </>
                  ),
                  onClick: () => {
                    navigate('/admin-dash/responses/' + examData._id);
                  },
                  variant: 'secondary',
                },
                {
                  value: (
                    <>
                      <FontAwesomeIcon
                        icon={faCircleQuestion}
                        size="sm"
                        className="me-2"
                      />
                      Logs
                    </>
                  ),
                  onClick: () => {
                    navigate('/admin-dash/logs/' + examData._id);
                  },
                  variant: 'secondary',
                },
                {
                  value: (
                    <>
                      <FontAwesomeIcon
                        icon={faSquarePollVertical}
                        size="sm"
                        className="me-2"
                      />
                      Results
                    </>
                  ),
                  onClick: () => {
                    navigate('/admin-dash/exam/' + examData._id + "/" + "result");
                  },
                  variant: 'secondary',
                },
              ]}
              size="sm"
            />
          </div>
        }
      />

      <CenterAdmin />

      <CardBasic
        cardClass="mt-3"
        title={
          <div className="d-flex justify-content-between">
            <h5>Mapped Candidates</h5>
            <div className="d-flex align-items-center gap-3 ">
              <div>
                <Select
                  options={cities}
                  className="w-100"
                  placeholder="Filter.."
                  value={selectedCity}
                  onChange={(e: any) => setSelectedCity(e)}
                  isClearable
                />
              </div>
              <Button variant='secondary' onClick={() => setShowCandidateDataModel(true)}>Upload File</Button>
              <Button variant="danger" onClick={() => setConfirmPrompt(true)}>Clear All Users</Button>
              {/* <Toolbar
                values={[
                  {
                    value: (
                      <>
                        <FontAwesomeIcon
                          icon={faUpload}
                          size="sm"
                          className="me-2"
                        />
                        Upload File
                      </>
                    ),
                    onClick: () => {
                      setShowCandidateDataModel(true);
                    },
                    variant: 'secondary',
                  },
                  {
                    value: (
                      <>
                        <FontAwesomeIcon
                          icon={faXmark}
                          size="sm"
                          className="me-2"
                        />
                        Clear All Users
                      </>
                    ),
                    onClick: () => {
                      setConfirmPrompt(true);
                    },
                    variant: 'danger',
                  }
                ]}
                size="sm"
              /> */}
            </div>

          </div>
        }
        body={
          <>
            <div className="mt-2">
              <ExamUserTable
                pageCount={pageCount}
                setPageCount={setPageCount}
                userData={userData}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                totalPages={totalPages}
                reloadData={getAllMappedUser}
              />
              {/* <div className="text-center">
                <TablePagination
                  total={total}
                  currentPage={pageNumber}
                  perPage={pageSize}
                  handlePageChange={(e: number) => {
                    setPageNumber(e)
                  }}
                  setPerPage={(e: number) => { setPageSize(e) }}
                />

              </div> */}
            </div>
          </>
        }
      />

      <UploadCandidateData
        show={showCandidateDataModal}
        setShow={setShowCandidateDataModel}
        candidateData={examData}
      />

      <Modal
        show={showPasswordModal}
        onHide={() => setShowPasswordModal(false)}
        animation={true}
        centered
      >
        <Modal.Header closeButton>

        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <FontAwesomeIcon icon={faKey} className='text-success' size="2x" />
            <div className="mt-3">
              <p className="text-center">Username: <strong>{clientPassword?.client?.username || "--"}</strong></p>
              <p className="text-center">Password: <strong>{clientPassword?.password || "--"}</strong></p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCreateClientModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showCreateClientModal}
        onHide={() => setShowCreateClientModal(false)}
        animation={true}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Client</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Username</Form.Label>
            <Form.Control onChange={(e: any) => setClientData(e.target.value)} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCreateClientModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleCreateClient}>
            Create
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showResetClientPasswordModal}
        onHide={() => setShowResetClientPasswordModal(false)}
        animation={true}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Client Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Password</Form.Label>
            <Form.Control onChange={(e: any) => setClientResetData(e.target.value)} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowResetClientPasswordModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleUpdateClientPassword}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
